import { render, staticRenderFns } from "./transportList.vue?vue&type=template&id=57a75a14&scoped=true&"
import script from "./transportList.vue?vue&type=script&lang=js&"
export * from "./transportList.vue?vue&type=script&lang=js&"
import style0 from "./transportList.vue?vue&type=style&index=0&id=57a75a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a75a14",
  null
  
)

export default component.exports